module.exports = __webpack_public_path__ + "static/media/RKProjectPrevieww935@1x.20c4f57a.webp";